import React from 'react';
import { Button } from 'react-bootstrap';
import './_card-mini.scss';

export default function MiniCardWithCta(props) {
  const { type = 1, iconSrc = '', title = '', description = '', btnText, btnUrl, openNewTab = false } = props;

  return (
    <>
      {type === 1 ? (
        <div className="mini-card mini-card-style-1">
          <div className="mini-card-icon">
            <img src={iconSrc} alt="..." />
          </div>
          <div className="mini-card-content">
            <div className="mini-card-title">{title}</div>
            <div className="mini-card-desc">{description}</div>
            {btnUrl && btnText && (
              <Button variant="primary" href={btnUrl} target={openNewTab ? '_blank' : ''}>
                {btnText}
              </Button>
            )}
          </div>
        </div>
      ) : (
        <div className="mini-card mini-card-style-2">
          <span className="mini-card-icon">
            <img src={iconSrc} alt="..." />
          </span>
          <span className="mini-card-content">
            <span className="mini-card-title">{title}</span>
            <span className="mini-card-desc">{description}</span>
          </span>
        </div>
      )
      }
    </>
  );
}
